export default {"src":"/_next/static/media/fedex.203b4cc4.svg","height":24,"width":87,"blurWidth":0,"blurHeight":0};